import { invokeApi } from "../invokeApi";

export const _List_Support_Tickets_For_Admin = async (data, page, limit) => {
  const requestObj = {
    path: `/api/support_ticket/list_support_tickets_for_admin?page=${page}&limit=${limit}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data || {},
  };
  return invokeApi(requestObj);
};

export const _Update_Support_Ticket = async (data, id) => {
  const requestObj = {
    path: `/api/support_ticket/update_support_ticket/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _Delete_Support_Ticket = async (id) => {
  const requestObj = {
    path: `/api/support_ticket/delete_support_ticket/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _Empty_Support_Ticket_Trash = async () => {
  const requestObj = {
    path: `/api/support_ticket/empty_support_ticket_trash`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _Mark_Resolve_Support_Ticket = async (id) => {
  const requestObj = {
    path: `/api/support_ticket/mark_resolve_support_ticket/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _List_Support_Ticket_Comments = async (supportTicketId) => {
  const requestObj = {
    path: `/api/support_ticket_comment/list_comment_with_support_ticket/${supportTicketId}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _Add_Support_Ticket_Comment = async (data) => {
  const requestObj = {
    path: `/api/support_ticket_comment/add_support_ticket_comment`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _Update_Support_Ticket_Comment = async (data, id) => {
  const requestObj = {
    path: `/api/support_ticket_comment/update_support_ticket_comment/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _Delete_Support_Ticket_Comment = async (id) => {
  const requestObj = {
    path: `/api/support_ticket_comment/delete_support_ticket_comment/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
